import { render, staticRenderFns } from "./BooleanDisplay.vue?vue&type=template&id=b80f5116&scoped=true&"
import script from "./BooleanDisplay.vue?vue&type=script&lang=js&"
export * from "./BooleanDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80f5116",
  null
  
)

export default component.exports